import api from './api'

export const saleService = {
  getAll: (params?: { status?: string; customer?: string; type?: string; search?: string; start_date?: string; end_date?: string; page?: number; limit?: number }) =>
    api.get('/sales', { params }),

  getById: (id: number | string) =>
    api.get(`/sales/${id}`),

  create: (data: any) =>
    api.post('/sales', data),

  confirm: (id: number | string) =>
    api.post(`/sales/${id}/confirm`),

  cancel: (id: number | string) =>
    api.post(`/sales/${id}/cancel`),

  addPayment: (id: number | string, data: any) =>
    api.post(`/sales/${id}/payment`, data),

  getTodaySales: () =>
    api.get('/sales/today'),

  getPendingPayments: () =>
    api.get('/sales/pending'),

  getPrintData: (id: number | string) =>
    api.get(`/sales/${id}/print`),

  scanBarcode: (barcode: string) =>
    api.post('/sales/scan', { barcode }),

  getProductHistory: (supplierId: number | string, productId: number | string) =>
    api.get(`/purchases/supplier/${supplierId}/product/${productId}/history`),
}
